import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ui } from '@/constants';

@Component({
    name: 'CmgRetroCreditConfirmNavModal',
})
export default class CmgRetroCreditConfirmNavModal extends Vue {
    get visible() {
        return this.$appStore.state.ui.modals.retroCreditConfirmNavModal.visible;
    }

    get width(): string {
        const width = this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneXsMax ? 290 : 370;

        return `${width}px`;
    }

    onClickConfirm() {
        const args = this.$appStore.state.ui.modals.retroCreditConfirmNavModal.args;
        if (args && args.onConfirm) {
            args.onConfirm();
        }

        this.close();
    }

    onClickCancel() {
        const args = this.$appStore.state.ui.modals.retroCreditConfirmNavModal.args;
        if (args && args.onCancel) {
            args.onCancel();
        }

        this.close();
        this.$services.ui.nextFocus('step-num');
    }

    private close() {
        this.$services.ui.setModalVisibility('retroCreditConfirmNavModal', false);
    }
}
